import {Style, Icon} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class FltCatLayer extends GeoJsonLayer {
    icon_cache = {};

    constructor( map, settings = {} ){
        settings["name"] = 'fltcat';
        settings["dynamic_time"] = true;
        settings["api_endpt"] = 'MetarJSON.php';
        if( settings.density == undefined ) settings['density'] = 2;
        if( settings.scale == undefined ) settings['scale'] = 1;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "name", "fltcat" );
        url.searchParams.set( "density", this.settings['density'] );
        return url.toString();
    }

    getIconSize( feature ){
        let size = 20*this.settings['scale'];
        return size;
    }

    getIcon( feature ){
        var params = "";
        if( this.property(feature,'fltcat') != undefined )
            params = params + "code=" + this.property(feature,'fltcat') + "&";
        params = params + "&scale="+this.settings['scale'];
        if( this.property(feature,'raw_taf') != undefined )
            params = params + "&shadow=000000";
        return this.icon_path + '/wxicon.php?'+params;
    }

    getStyle(feature, resolution ){
        let size = this.getIconSize(feature);
        let icon;
        if( this.icon_cache[ feature.getId()] )
            icon = this.icon_cache[feature.getId()];
        else {
            icon = new Icon({
                    "src": this.getIcon(feature),
                    "imgSize": [size,size]
                    });
            this.icon_cache[feature.getId()] = icon;
        }

        let style = new Style({
                "image": icon
                });
        return style;
    }

    getPopupText( feature ){
        let text = this.popupTitle( "FLTCAT", this.property(feature,'id')+" ["+this.property(feature,'site')+ "]" );;
        if( this.property(feature,'ceil') != undefined ){
            var color = "#00AA33";
            if( this.property(feature,'ceil') < 5 )
                color = "#FF00CC";
            else if( this.property(feature,'ceil') < 10 )
                color = "#FF0000";
            else if( this.property(feature,'ceil') <= 30 )
                color = "#0000EE";
            text += this.popupData( "Ceiling", this.property(feature,'ceil')+"00 ft", color );
        }
        var visib = this.property(feature,'visib');
        if( visib != undefined ){
            var color = "#00AA33";
            if( visib < 1 )
                color = "#FF00CC";
            else if( visib < 3 )
                color = "#FF0000";
            else if( visib <= 5 )
                color = "#0000EE";
            if( visib == 6.21 )
                visib = "6+";
            text += this.popupData( "Visibility", visib + "sm", color );
        }
        text += this.popupSep();
        // Raw TAF from TAF data
        if( this.property(feature,'raw_taf') != undefined ){
            var taf = this.property(feature,'raw_taf').replace( "FROM", "<br/>&nbsp;&nbsp;FROM" );
            taf = taf.replace( /FM0/g, "<br/>&nbsp;&nbsp;FM0" );
            taf = taf.replace( /FM1/g, "<br/>&nbsp;&nbsp;FM1" );
            taf = taf.replace( /FM2/g, "<br/>&nbsp;&nbsp;FM2" );
            taf = taf.replace( /FM3/g, "<br/>&nbsp;&nbsp;FM3" );
            taf = taf.replace( /TEMPO/g, "<br/>&nbsp;&nbsp;TEMPO" );
            taf = taf.replace( /BECMG/g, "<br/>&nbsp;&nbsp;BECMG" );
            taf = taf.replace( /PROB/g, "<br/>&nbsp;&nbsp;PROB" );
            taf = taf.replace( /INTER/g, "<br/>&nbsp;&nbsp;INTER" );
            text += this.popupData( "TAF", taf );;
        }
        else
            text += this.popupData( "METAR", this.property(feature,'raw_ob'));;
        text += this.popupEnd();
        return text;
    }

    updateTime(){
        this.refresh();
    }
}
